module.exports = __webpack_public_path__ + "static/media/uwasa-logo.94e23561.jpg";